"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var entries_fetch_request_serialiser_1 = require("./../services/log-retrieval/entries-fetch-request-serialiser");
var entries_fetch_response_serialiser_1 = require("./../services/log-retrieval/entries-fetch-response-serialiser");
exports.FETCH_LOG_ENTRIES_SERVICE = {
    id: 132,
    request: entries_fetch_request_serialiser_1.EntriesFetchRequestSerialiser,
    response: entries_fetch_response_serialiser_1.EntriesFetchResponseSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/log-retrieval-services.js
// module id = 1968
// module chunks = 1